/** Width of the desktop sidebar in expanded mode, in pixels. */
export const SIDEBAR_WIDTH = 276;
/** Width of the sidebar in compact rail mode, in pixels. */
export const SIDEBAR_RAIL_WIDTH = 64;
/** Width of the chat history panel in expanded / peek modes. */
export const CHAT_HISTORY_WIDTH = 268;
/** Width of the Copilot right rail when open. */
export const COPILOT_RAIL_WIDTH = 380;
/** Width of the Copilot right rail's collapsed edge tab. */
export const COPILOT_RAIL_EDGE_WIDTH = 36;
/** Hover-peek timing — gives just enough breathing room to feel intentional. */
export const PEEK_OPEN_DELAY_MS = 140;
export const PEEK_CLOSE_DELAY_MS = 220;
